import * as z from "zod";
import type { TFunction } from "i18next";

import { requiredApiDecimalString } from "@/shared/utils";

const DATE_STRING_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const requiredText = (t: TFunction, key: string) =>
  z.string().trim().min(1, t(key));

const requiredDateString = (
  t: TFunction,
  requiredKey: string,
  invalidKey: string,
) =>
  z
    .string()
    .trim()
    .min(1, t(requiredKey))
    .refine((value) => DATE_STRING_PATTERN.test(value), t(invalidKey));

const damRaisingMethodValues = ["downstream", "upstream", "centerLine"] as const;

/** PRD admin-structures.md §4.2 — sub-modal Novo/Editar alteamento. */
export const createAdminStructureRaisingHistorySchema = (t: TFunction) =>
  z.object({
    executiveProjectDesigner: requiredText(
      t,
      "admin.structures.raisingHistory.validation.executiveProjectDesignerRequired",
    ),
    stage: requiredText(
      t,
      "admin.structures.raisingHistory.validation.stageRequired",
    ),
    method: z.enum(damRaisingMethodValues, {
      required_error: t(
        "admin.structures.raisingHistory.validation.methodRequired",
      ),
    }),
    elevation: requiredApiDecimalString(
      t,
      "admin.structures.raisingHistory.validation.elevationRequired",
      "admin.structures.raisingHistory.validation.elevationInvalid",
    ),
    occurredOn: requiredDateString(
      t,
      "admin.structures.raisingHistory.validation.occurredOnRequired",
      "admin.structures.raisingHistory.validation.occurredOnInvalid",
    ),
  });

export type AdminStructureRaisingHistoryForm = z.infer<
  ReturnType<typeof createAdminStructureRaisingHistorySchema>
>;
